import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a4ac6f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "faq-page" }
const _hoisted_2 = { class: "faq-wrap" }
const _hoisted_3 = { class: "t-container" }
const _hoisted_4 = { class: "faq-wrap-leftmenu" }
const _hoisted_5 = { class: "faq-wrap-leftmenu__top" }
const _hoisted_6 = { class: "faq-wrap-leftmenu__list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "faq-wrap-content"
}
const _hoisted_9 = { class: "faq-wrap-content__item--hd" }
const _hoisted_10 = { class: "faq-wrap-content__item--title" }
const _hoisted_11 = { class: "faq-wrap-content__item--tag" }
const _hoisted_12 = { class: "faq-wrap-content__item--subtitle" }
const _hoisted_13 = {
  key: 0,
  class: "faq-wrap-content__item--subtitle"
}
const _hoisted_14 = {
  key: 1,
  class: "faq-wrap-content__item--text"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" A: ")
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = /*#__PURE__*/_createTextVNode("点击查看更多")
const _hoisted_18 = {
  key: 1,
  class: "faq-wrap-content--nodata"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Submenu = _resolveComponent("Submenu")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Submenu, {
      page: "faq",
      hasLogin: _ctx.hasLogin,
      activeTab: _ctx.pageState.activeTab,
      changeTab: _ctx.changeTab
    }, null, 8, ["hasLogin", "activeTab", "changeTab"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchKey) = $event)),
              maxlength: "30",
              placeholder: "请输入问题关键词",
              class: "faq-wrap-leftmenu__ipt",
              onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.searchQues && _ctx.searchQues(...args)), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.searchKey]
            ]),
            _createElementVNode("img", {
              src: "https://static.wecity.qq.com/miying/searchIcon-665e68206a014fde25c463c3b5bb1887.png",
              alt: "",
              class: "faq-wrap-leftmenu__searchIcon",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.searchQues && _ctx.searchQues(...args)))
            })
          ]),
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (ques, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: _normalizeClass(['faq-wrap-leftmenu__item', _ctx.pageState.activeCate === index ? 'active' : '']),
                onClick: ($event: any) => (_ctx.clickCategory(index))
              }, _toDisplayString(ques), 11, _hoisted_7))
            }), 128))
          ])
        ]),
        (_ctx.pageState.hasQues)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageState.quesList, (ques, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "faq-wrap-content__item"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, "Q:" + _toDisplayString(ques.Title), 1),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(ques.Theme), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(ques.Question), 1),
                  (ques.State === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, "正在加速解答中，请耐心等待"))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("span", {
                          innerHTML: ques.Answer
                        }, null, 8, _hoisted_16)
                      ]))
                ]))
              }), 128)),
              (_ctx.pageState.showMoreButton)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    class: "self-faq-wrap-content__morebtn",
                    loading: !_ctx.pageState.allowClick,
                    onClick: _ctx.clickMore
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_18, "暂无相关问题"))
      ])
    ])
  ]))
}